module.exports = __webpack_public_path__ + "static/media/crm.017a459b.png";